import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';

import CategoryCommand from './CategoryCommand';

class FilterByColumnCommand extends CategoryCommand<void> {
  public static COMMAND_NAME = 'filterByColumn' as const;

  public isAvailable(context: ClientContext): boolean {
    return (
      context.has('ParentCategory') ||
      context.get('InParams')?.linksGraph?.mode !== DocLinksMode.SINGLE
    );
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.FILTER_BY_COLUMN,
    };
  }

  public getIcon(): IconName {
    return 'filter-column';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.FilterByColumn;
  }

  public getName(): CommandName {
    return FilterByColumnCommand.COMMAND_NAME;
  }
}

export default FilterByColumnCommand;
